import {
  empty,
  sortArrayByDate
} from '@/lib/utils'
import { handleize } from '../../lib/utils';
import moment from 'moment'

const EXAMS_MAP = {
  EXAM_GRE: handleize('GRE'),
  EXAM_CASPER: handleize('CASper'),
  EXAM_MCAT: handleize('MCAT'),
  EXAM_TOEFL_IBT: handleize('TOEFL iBT'),
  EXAM_TOEFL_PBT: handleize('TOEFL PBT'),
  EXAM_PTE_ACADEMIC: handleize('PTE Academic'),
  EXAM_IELTS: handleize('IELTS'),
  EXAM_MELAB: handleize('MELAB'),
  EXAM_ITEP_ACADEMIC: handleize('iTEP Academic'),
}

function getExamGroup (exam_type) {
  for (const key in EXAMS_MAP) {
    if (EXAMS_MAP.hasOwnProperty(key)) {
      const type = EXAMS_MAP[key];
      if (type === handleize(exam_type)) return key
    }
  }
}

function basicExamTypeCheck (userExams, examType, savedSchool, schoolMinKey, examScoreKey, schoolReqKey) {
  // console.log('REQUIRED CHECK: ', schoolReqKey, 'is', savedSchool[schoolReqKey])
  if (empty(savedSchool[schoolReqKey]) || !savedSchool[schoolReqKey]) return false
  const currentExams = !userExams[examType] ? [] : userExams[examType].filter((exam) => {
    return moment().diff( moment(exam.date, 'YYYY-MM-DD'), 'days' ) <= (2 * 365)
  })
  if (!currentExams || !Array.isArray(currentExams)) return false
  if (currentExams.length === 0) return false
  if (empty(savedSchool[schoolMinKey]) && currentExams.length) return true
  if (empty(currentExams[0][examScoreKey])) return false
  return Number(currentExams[0][examScoreKey]) >= Number(savedSchool[schoolMinKey])
}

export default {
  computed: {
    needsInternaltionalChecks () {
      return (
        this.user.user_profile.applicant_international_status === 'true' &&
        this.savedSchool.accepts_international_students &&
        (this.savedSchool.toefl_required ||
        this.savedSchool.ielts_required ||
        this.savedSchool.melab_required ||
        this.savedSchool.pteAcademic_required ||
        this.savedSchool.itepAcademicPlus_required
        )
      )
    },
    userExams () {
      const exams = {}
      const sortedExams = {}
      for (const examID in this.user.exams) {
        if (this.user.exams.hasOwnProperty(examID)) {
          const exam = this.user.exams[examID];
          if (!exam || !exam.examStatus) continue;
          if (handleize(exam.examStatus) !== 'completed') continue
          const group = getExamGroup(exam.exam_type)
          if (!exams[group]) {
            exams[group] = []
          }
          exam.id = examID
          exams[group].push(exam)
        }
      }
      for (const key in exams) {
        if (exams.hasOwnProperty(key)) {
          const examsGroup = exams[key];
          sortedExams[key] = sortArrayByDate(examsGroup, 'date')
        }
      }
      return sortedExams
    },
    toefelMinTimeoutDays () {
      return (empty(this.savedSchool.toefl_minimum_years_completed) ? 2 : Number(this.savedSchool.toefl_minimum_years_completed)) * 365
    },

    userClears_TOEFL_IBT () {
      const userExams = this.userExams['EXAM_TOEFL_IBT']
      const filteredExams = !userExams ? [] : userExams.filter((exam) => {
        return moment().diff( moment(exam.date, 'YYYY-MM-DD'), 'days' ) <= this.toefelMinTimeoutDays
      })

      if (filteredExams.length === 0) return false

      if (
        (
          empty(this.savedSchool.toefl_minimum_computer_score) &&
          empty(this.savedSchool.toefl_ibt_minimum_reading_score) &&
          empty(this.savedSchool.toefl_ibt_minimum_writing_score) &&
          empty(this.savedSchool.toefl_ibt_minimum_listening_score) &&
          empty(this.savedSchool.toefl_ibt_minimum_speaking_score)
        ) && filteredExams.length === 0
      ) return true

      const selectedExam = filteredExams[0]

      if (!empty(this.savedSchool.toefl_minimum_computer_score)) {
        if (empty(selectedExam.toeflIbt_total_score) || isNaN(Number(selectedExam.toeflIbt_total_score))) return false
        if (Number(this.savedSchool.toefl_minimum_computer_score) > Number(selectedExam.toeflIbt_total_score)) return false
      }

      if (!empty(this.savedSchool.toefl_ibt_minimum_reading_score)) {
        if (empty(selectedExam.toeflIbt_reading_score) || isNaN(Number(selectedExam.toeflIbt_reading_score))) return false
        if (Number(this.savedSchool.toefl_ibt_minimum_reading_score) > Number(selectedExam.toeflIbt_reading_score)) return false
      }

      if (!empty(this.savedSchool.toefl_ibt_minimum_writing_score)) {
        if (empty(selectedExam.toeflIbt_writing_score) || isNaN(Number(selectedExam.toeflIbt_writing_score))) return false
        if (Number(this.savedSchool.toefl_ibt_minimum_writing_score) > Number(selectedExam.toeflIbt_writing_score)) return false
      }

      if (!empty(this.savedSchool.toefl_ibt_minimum_listening_score)) {
        if (empty(selectedExam.toeflIbt_listening_score) || isNaN(Number(selectedExam.toeflIbt_listening_score))) return false
        if (Number(this.savedSchool.toefl_ibt_minimum_listening_score) > Number(selectedExam.toeflIbt_listening_score)) return false
      }

      if (!empty(this.savedSchool.toefl_ibt_minimum_speaking_score)) {
        if (empty(selectedExam.toeflIbt_speaking_score) || isNaN(Number(selectedExam.toeflIbt_speaking_score))) return false
        if (Number(this.savedSchool.toefl_ibt_minimum_speaking_score) > Number(selectedExam.toeflIbt_speaking_score)) return false
      }

      return true
    },

    userClears_TOEFL_PBT () {
      const userExams = this.userExams['EXAM_TOEFL_PBT']
      if (!userExams) return false
      const filteredExams = !userExams ? [] : userExams.filter((exam) => {
        return moment().diff( moment(exam.date, 'YYYY-MM-DD'), 'days' ) <= this.toefelMinTimeoutDays
      })

      if (filteredExams.length === 0) return false

      if (
        (
          empty(this.savedSchool.toefl_minimum_written_score) &&
          empty(this.savedSchool.toefl_pbt_minimum_reading_score) &&
          empty(this.savedSchool.toefl_pbt_minimum_written_score) &&
          empty(this.savedSchool.toefl_pbt_minimum_listening_score)
        ) && filteredExams.length === 0
      ) return true

      const selectedExam = filteredExams[0]
      if (!empty(this.savedSchool.toefl_minimum_written_score)) {
        if (empty(selectedExam.toeflPbt_total_score) || isNaN(Number(selectedExam.toeflPbt_total_score))) return false
        if (Number(this.savedSchool.toefl_minimum_written_score) > Number(selectedExam.toeflPbt_total_score)) return false
      }

      if (!empty(this.savedSchool.toefl_pbt_minimum_reading_score)) {
        if (empty(selectedExam.toeflPbt_reading_score) || isNaN(Number(selectedExam.toeflPbt_reading_score))) return false
        if (Number(this.savedSchool.toefl_pbt_minimum_reading_score) > Number(selectedExam.toeflPbt_reading_score)) return false
      }

      if (!empty(this.savedSchool.toefl_pbt_minimum_written_score)) {
        if (empty(selectedExam.toeflPbt_writing_score) || isNaN(Number(selectedExam.toeflPbt_writing_score))) return false
        if (Number(this.savedSchool.toefl_pbt_minimum_written_score) > Number(selectedExam.toeflPbt_writing_score)) return false
      }

      if (!empty(this.savedSchool.toefl_pbt_minimum_listening_score)) {
        if (empty(selectedExam.toeflPbt_listening_score) || isNaN(Number(selectedExam.toeflPbt_listening_score))) return false
        if (Number(this.savedSchool.toefl_pbt_minimum_listening_score) > Number(selectedExam.toeflPbt_listening_score)) return false
      }

      return true
    },
    userClears_TOEFL () {
      if (empty(this.savedSchool.toefl_required) || !this.savedSchool.toefl_required) return false
      if (this.savedSchool.toefl_exempt_masters_doctoral_degrees === true) return this.hasMastersForDoctorate
      return this.userClears_TOEFL_IBT || this.userClears_TOEFL_PBT
    },
    userClears_IELTS () {
      return basicExamTypeCheck(
        this.userExams,
        'EXAM_IELTS',
        this.savedSchool,
        'ielts_minimum_score',
        'ielts_overall_score',
        'ielts_required'
      )
    },
    userClears_MELAB () {
      return basicExamTypeCheck(
        this.userExams,
        'EXAM_MELAB',
        this.savedSchool,
        'melab_minimum_score',
        'melab_overall_score',
        'melab_required'
      )
    },
    userClears_PTEAcademic () {
      return basicExamTypeCheck(
        this.userExams,
        'EXAM_PTE_ACADEMIC',
        this.savedSchool,
        'pteAcademic_minimum_score',
        'pteAcademic_overall_score',
        'pteAcademic_required'
      )
    },
    userClears_iTEPAcademic () {
      return basicExamTypeCheck(
        this.userExams,
        'EXAM_ITEP_ACADEMIC',
        this.savedSchool,
        'itepAcademicPlus_minimum_score',
        'itepAcademic_overall_score',
        'itepAcademicPlus_required'
      )
    },
    clearInternationalChecks () {
      if (!(!!this.user.user_profile.applicant_international_status)) return false
      if (!this.savedSchool.accepts_international_students) return false
      return (
        this.userClears_TOEFL ||
        this.userClears_IELTS ||
        this.userClears_MELAB ||
        this.userClears_PTEAcademic ||
        this.userClears_iTEPAcademic
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkinternationalexamsmixin.js